export default "__VITE_ASSET__BMpI5DBN__"